import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_YIPPI_API_WALLETURL
})

instance.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  config.headers['Accept-Language'] = localStorage.getItem('language')
  return config
})
export default instance
